import React, { Fragment } from 'react';
const nlRegex = new RegExp(/(?:\r\n|\r|\n)/gim);
export const Nl2Br = ({ message }) => {
    const parts = message === null || message === void 0 ? void 0 : message.split(nlRegex);
    return (React.createElement(React.Fragment, null, parts === null || parts === void 0 ? void 0 : parts.map((part, index) => {
        return (React.createElement(Fragment, { key: index },
            index > 0 && React.createElement("br", null),
            part));
    })));
};
//# sourceMappingURL=Nl2br.js.map